/* eslint-disable prettier/prettier */
// src/pages/privates/Tools/index.tsx
import React, { useEffect, useState } from 'react';

import { IoArrowBack, IoClose, } from 'react-icons/io5';
import { RiMailSendFill } from 'react-icons/ri';
import { useHistory } from 'react-router-dom';

import {
    HeaderNavigationPrivate,
    MenuSideBarPrivate,
    SubtitleSecondary,
    CardHorizontalButtonNavigate,
    LoadingList,
    ButtonDefault,
    InputSelect,
    ButtonMain,
    InputText,
    Paragraph,
} from '@components/index';
import { ConfigStyles } from '@config/index';
import Contract from '@models/Contract';
import { ModalSimpleFilter } from '@pages/private/User/styles';
import { apiRebox } from '@services/index';
import { toastify } from '@utils/notifiers';

import { FormFilter, FilterFieldSet } from '../HandChat/styles';
import {
    Container,
    ContainerGroup,
    Content,
    Options,
    OptionsGroup,
} from './styles';


const AutentiqueTrigger: React.FC = () => {
    const { goBack } = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isOpenModalFilter, setIsOpenModalFilter] = useState<boolean>(false);
    const [cpf, setCpf] = useState<string>('');
    const [contract, setContract] = useState<Contract>({} as Contract)

    const handleGoBack = () => {
        goBack();
    };

    const handleCpf = (event: any) => {
        setCpf(event.target.value)
    }

    const getCustomerByCpf = async () => {
        const { data: { data: [user] } } = await apiRebox.get(`/users?${cpf.length === 11 ? 'cpf' : 'cnpj'}=${cpf}`)
        if (user && user.gateway_traccar_user_id) {
            const [trackerContract]: Contract[] = user.contracts.filter((userContract: Contract) => ['RELEASED'].includes(userContract.status))
            setContract(trackerContract)
        }
    }

    const sendContract = async () => {
        try {
            await apiRebox.post(`/notifications/autentique/${contract.id}`)
            toastify('Contrato enviado com sucesso', 'success')
        } catch (error) {
            toastify('Houve um erro ao enviar o contrato', 'error')
        }
    }



    useEffect(() => {
        getCustomerByCpf()
    }, [cpf])

    return (
        <Container>
            <HeaderNavigationPrivate />
            <ContainerGroup>
                <MenuSideBarPrivate />
                <Content>
                    <SubtitleSecondary textAlign="start">Disparador Autentique</SubtitleSecondary>
                    <Options>
                        <OptionsGroup>
                            <ButtonDefault iconLeft={IoArrowBack} onClick={handleGoBack} />
                        </OptionsGroup>
                    </Options>

                    <ModalSimpleFilter
                        ariaHideApp={false}
                        isOpen={isOpenModalFilter}
                        onRequestClose={() => {
                            setIsOpenModalFilter(prevState => !prevState);
                        }}
                        contentLabel="SimpleFilterCustomer"
                    >
                        <ButtonDefault
                            iconLeft={IoClose}
                            style={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                maxWidth: 50,
                                padding: 0,
                            }}
                            onClick={
                                () => {
                                    setIsOpenModalFilter(prevState => !prevState)
                                    setCpf('')
                                }
                            }
                        />
                        <FormFilter ref={() => ([])} onSubmit={() => sendContract()}>
                            <FilterFieldSet>
                                <Paragraph
                                    nameColor="black"
                                    textAlign="start"
                                    style={{ marginBottom: '1vh', fontWeight: 500 }}
                                >
                                    Busca por CPF / CNPJ
                                </Paragraph>
                                <InputText name="cpfcnpj" placeholder="CPF ou CNPJ" tabIndex={1}
                                    onChange={handleCpf} />
                            </FilterFieldSet>

                            <ButtonMain style={{ marginTop: '0.5rem' }} type="submit" >
                                Enviar Contrato
                            </ButtonMain>
                        </FormFilter>
                    </ModalSimpleFilter>

                    <CardHorizontalButtonNavigate
                        icon={{
                            element: RiMailSendFill,
                            size: 20,
                            opacity: 1,
                            colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                            colorHover: ConfigStyles.rebox.colors.white.main,
                        }}
                        label={{
                            text: 'Disparo do Contrato de Comodato',
                            colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                            colorHover: ConfigStyles.rebox.colors.blue.main,
                        }}
                        message={{
                            text: 'Insira o CPF/CNPJ do cliente que deve receber o contrato manualmente.',
                            colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                            colorHover: ConfigStyles.rebox.colors.blue.main,
                        }}
                        marginBottom="2vh"
                        positionContent="center"
                        onClick={() => setIsOpenModalFilter(prevState => !prevState)}
                    />
                    {isLoading && <LoadingList loading={isLoading} />}
                </Content>
            </ContainerGroup>
        </Container>
    );
};

export default AutentiqueTrigger;
